<template>
    <div>
      <el-dialog
        :title="title"
        :visible="isShowLoginDialog"
        width="30%"
        @close="handleDialog"
        @open="init"
        :close-on-click-modal="false"
      >

      <a id="login_tg_url" target="view_window" :href="url">{{msg}}</a>

    </el-dialog>
    </div>
  </template>
  <script>

  export default {
    props: {
      isShowLoginDialog: {
        type: Boolean,
        default: false,
      },
      url: {
        type: String,
        default: '',
      },
      msg: {
        type: String,
        default: '',
      },
    },
    data() {
      return {
        title:'登录验证',
        rules: {},
      }
    },
    methods: {
      init(){
      },
      handleDialog() {
        this.$emit('update:isShowLoginDialog', false)
      },
      submit() {
      },
    },
  }
  </script>